<template>
  <div class="contact-container">
    <!-- 标题与搜索框 -->
 

    <!-- 联系人卡片列表 -->
    <div class="contact-list">
      <div 
        v-for="contact in filteredContacts"
        :key="contact.id"
        class="contact-card"
      >
        <div class="avatar">{{ contact.name.charAt(0) }}</div>
        <div class="info">
          <p class="phone">岗位： {{ formatPhone(contact.gw) }}</p>
          <p class="phone">姓名：{{ contact.name }}</p>
          <p class="phone">电话：{{ formatPhone(contact.phone) }}</p>
  
        </div>
        <a :href="`tel:${contact.phone}`" class="call-button">
          <i class="icon-call"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

// 模拟数据
const contacts = ref([
  { id: 1, name: '黄浩林', phone: '13332958870',gw:'陕、甘、青、宁、新省区经理' },
  { id: 2, name: '李英帅', phone: '13834643777',gw:'山西省、蒙西省区经理' },
  { id: 3, name: '姜耀攀', phone: '15133124419',gw:'京、津、龚省区经理' },
  { id: 4, name: '尹兵', phone: '13793146779',gw:'山东省省区经理' },
  { id: 5, name: '王积善', phone: '13815418698',gw:'江苏省、上海省区经理' },
  { id: 6, name: '刘香丽', phone: '15020503788',gw:'浙江省、皖南省区经理' },
  { id: 7, name: '王鹏', phone: '13453130091',gw:'吉林、蒙东、辽宁、黑龙江省区经理' },
  { id: 8, name: '李勇', phone: '17737999965',gw:'河南省、皖北省区经理' },
  { id: 9, name: '张健', phone: '15035197747',gw:'湖北、湖南省区经理' },
  { id: 10, name: '张云', phone: '13661311858',gw:'江西、福建省区经理' },
  { id: 11, name: '黄俊龙', phone: '13913876905',gw:'广东、广西、海南省区经理' },
  { id: 12, name: '梁仲伦', phone: '13618056138',gw:'云南、贵州省区经理' },
  { id: 13, name: '张振球', phone: '13880904359',gw:'四川、重庆、西藏省区经理' },
  // ...其他10+条数据
])

// 搜索功能
const searchKeyword = ref('')
const filteredContacts = computed(() => {
  return contacts.value
    .filter(c => c.name.includes(searchKeyword.value))
    .sort((a,b) => a.name.localeCompare(b.name))
})

// 电话号码格式化
const formatPhone = (num) => {
  return num.replace(/(\d{3})(\d{4})(\d{4})/, '$1 $2 $3')
}
</script>

<style scoped>
/* 容器样式 */
.contact-container {
 
  margin: 20px auto;
  padding: 0 15px;
}

/* 标题区域 */
.header {
  margin-bottom: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
}
.title {
  font-size: 24px;
  color: #2c3e50;
  margin-bottom: 15px;
}

/* 搜索框 */
.search-box {
  position: relative;
  max-width: 400px;
}
.search-input {
  width: 100%;
  padding: 12px 40px 12px 20px;
  border: 2px solid #e0e0e0;
  border-radius: 25px;
  font-size: 16px;
  transition: border-color 0.3s;
}
.search-input:focus {
  border-color: #3498db;
  outline: none;
}
.icon-search {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #95a5a6;
}

/* 联系人卡片 */
.contact-list {
 
  gap: 15px;
}
.contact-card {
  float: left;
  text-align: left;
  width: 33%;
  display: flex;
  align-items: center;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.2s;
}
.contact-card:hover {
  transform: translateY(-2px);
}

/* 头像样式 */
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #3498db;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-right: 20px;
}

/* 信息区域 */
.name {
  font-size: 18px;
  margin-bottom: 5px;
  color: #2c3e50;
}
.phone {
  color: #7f8c8d;
  font-size: 15px;
}

/* 拨号按钮 */
.call-button {
  margin-left: auto;
  padding: 10px;
  color: #3498db;
  transition: color 0.3s;
}
.call-button:hover {
  color: #2980b9;
}

@media (max-width: 768px) {
  .contact-card {
    padding: 15px;
  }
  .avatar {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
}
</style>
